/*
 * Adds a `scrolling` attribute to a custom element when user is scrolling
 *
 */

type CustomElement = new (...args: any[]) => HTMLElement

export function IsScrollingMixin<TBase extends CustomElement>(Base: TBase) {
  return class extends Base {
    #scrollingTimeout

    connectedCallback() {
      // @ts-ignore
      super.connectedCallback?.()
      document.addEventListener('scroll', this.#handleScroll)
    }

    disconnectedCallback() {
      // @ts-ignore
      super.disconnectedCallback?.()
      document.removeEventListener('scroll', this.#handleScroll)
    }

    #handleScroll = () => {
      if (this.#scrollingTimeout) {
        clearTimeout(this.#scrollingTimeout)
      } else {
        this.setAttribute('scrolling', '')
      }

      this.#scrollingTimeout = setTimeout(() => {
        this.removeAttribute('scrolling')
        this.#scrollingTimeout = null
      }, 300)
    }
  }
}
